import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';

import type { FlyoutCloseHandlerProp } from '@atlassian/entry-point-flyout';
import type {
	ObjectListFlyoutProps,
	ObjectListFlyoutItem,
} from '@atlassian/navigation-common/types';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ObjectListFlyoutEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	Record<string, never>,
	ObjectListFlyoutProps<ObjectListFlyoutItem<object>> & FlyoutCloseHandlerProp,
	Record<string, never>
>;

export const objectListFlyoutEntrypoint: EntryPoint<ObjectListFlyoutEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<ObjectListFlyoutEntrypointComponent>(
			/* webpackChunkName: "@atlaskit-internal_async-object-list-flyout-entrypoint" */ './index',
			{ moduleId: 'objectListFlyoutEntrypoint' },
		),
		getPreloadProps: () => ({}),
	});
